module.exports = __webpack_public_path__ + "img/discover.5554bef2.svg";